import { render, staticRenderFns } from "./AudienceEdit.vue?vue&type=template&id=e958811c&scoped=true&"
import script from "./AudienceEdit.vue?vue&type=script&lang=js&"
export * from "./AudienceEdit.vue?vue&type=script&lang=js&"
import style0 from "./AudienceEdit.vue?vue&type=style&index=0&id=e958811c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e958811c",
  null
  
)

export default component.exports